import { makeStyles } from "tss-react/mui";

import { Box, Typography } from "@mui/material";
import { alpha, Theme } from "@mui/material/styles";

const useStyles = makeStyles()((theme: Theme) => {
    const isDark = theme.palette.mode === "dark";
    return {
        header: {
            display: "flex",
            alignItems: "flex-start",
            gap: theme.spacing(3),
            marginBottom: theme.spacing(5),
            flexShrink: 0,
        },
        headerWithoutDescription: {
            marginBottom: theme.spacing(5),
            flexShrink: 0,
        },
        iconWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 60,
            height: 60,
            marginTop: 4,
            minHeight: 48,
            borderRadius: 12,
            backgroundColor: isDark ? alpha(theme.palette.emteria.text.primary, 0.15) : alpha(theme.palette.emteria.action, 0.08),
            flexShrink: 0,
        },
        icon: {
            fontSize: 20,
            color: isDark ? theme.palette.emteria.text.primary : theme.palette.emteria.action,
        },
        textBlock: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
            justifyContent: "center",
            minHeight: 48,
        },
        title: {
            color: isDark ? theme.palette.emteria.text.primary : theme.palette.emteria.primary,
        },
        description: {
            color: theme.palette.text.primary,
        },
    };
});

type Props = {
    iconName: string;
    title: string;
    description?: React.ReactNode;
};

const PageHeader = (props: Props) => {
    const { classes, cx } = useStyles();

    return (
        <Box className={classes.header}>
            <Box className={classes.iconWrapper}>
                <i className={cx(props.iconName, classes.icon)} />
            </Box>
            <Box className={classes.textBlock}>
                <Typography variant="h6" fontWeight="bold" className={classes.title}>
                    {props.title}
                </Typography>
                {props.description ? (
                    <Typography variant="body1" className={classes.description}>
                        {props.description}
                    </Typography>
                ) : null}
            </Box>
        </Box>
    );
};

export default PageHeader;
